export const DELETE_STATEMENT_TEMPLATE_SUCCESS = 'DELETE_STATEMENT_TEMPLATE_SUCCESS';

export const deleteStatementTemplateSuccess = (id) => ({
    type: DELETE_STATEMENT_TEMPLATE_SUCCESS,
    payload: {
        id
    },
});
